<template>
<div class="body">
    <div class="headbox">
        <tiao :neir="'密码修改'">

        </tiao>
    </div>
    <div class="mimabox">
      <div class="sp1">
          <div >姓名：{{username}}</div>
          <div>用户名：{{phone}}</div>
      </div>
        <div class="sp2">
                <div class="listbox">
                    <div style="width:80px ">
                        原始密码:
                    </div>
                    <div style="width: 180px">
                        <input v-model="pwd" class="smallp" type="password">
                    </div>
                </div>
            <span style="color:red" v-if="show_one">原始密码输入错误</span>
            <div class="listbox">

            </div>
        </div>


        <div class="sp2">
            <div class="listbox">
                <div style="width:80px ">
                    新密码:
                </div>
                <div style="width: 180px">
                    <input v-model="newpwd" class="smallp" type="password">
                </div>
            </div>
            <span style="color:red" v-if="show_six">请输入6-20个数字和字母</span>
            <div class="listbox">

            </div>
        </div>
        <div class="sp2">
            <div class="listbox">
                <div style="width:80px ">
                    确认密码：
                </div>
                <div style="width: 180px">
                    <input class="smallp" v-model="newpwds" type="password">
                </div>
            </div>
            <span style="color: red;" v-if="show_two">两次输入密码不一致,请重新输入</span>
            <div class="listbox">

            </div>
        </div>

        <div class="qrxg" @click="gai">
            确认修改
        </div>

    </div>

</div>

</template>

<script>
    import tiao from '@/components/tiao'
    export default {
        components:{
            tiao
        },
    data() {
        return {
            pwd:'',
            newpwd:'',
            newpwds:'',
            token:'',
            username:'',
            phone:'',
            show_six:false,
            show_two:false,
            show_one:false,
        };
    },
    methods:{
        jump:function (d) {
         this.$router.push(d)
        },
        gai:function () {
            let self=this;
            $.ajax({
                type: 'post',
                url: process.env.apiUrl + "saas/Mima/index",
                data: {
                    token:self.token,
                    pwd:self.pwd,
                    newpwd:self.newpwd,
                    newpwds:self.newpwds
                },
                success: function (data) {
                    if(data.status==1){
                        self.$message.success(data.msg);
						self.pwd=''
						self.newpwd=''
						self.newpwds=''
                    }else{
                        self.$message.error(data.msg);
                    }
                },
                error:function () {
                    self.$message.error(`请求失败`);
                }
            });

        }

    },
        mounted:function () {
            let self=this;
            self.token=self.$cookies.get('token');
            $.ajax({
                type: 'post',
                url: process.env.apiUrl + "saas/Mima/index2",
                data: {
                    token:self.token
                },
                success: function (data) {
                    if(data.status){
                        self.$message.error(data.msg);
                    }else{
                        self.username=data.username
                        self.phone=data.phone
                    }
                },
                error:function () {
                    self.$message.error(`请求失败`);
                }
            });
        }

}
</script>

<style scoped>
    .body{
        padding-left: 45px;
        padding-right: 45px;
        font-size: 14px;
        color: #666;
    }
    .headbox{
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .mimabox{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border: 1px solid rgb(219, 219, 219);
    }
    .sp1{
        background: rgb(241, 240, 241)
    }
    .sp1 > div {
        padding-left: 15px;
        line-height: 44px;
        height: 44px;
        display: inline-block;
        font-size: 14px;
        width: 280px;
    }
    .listbox{
        display: flex;
        display: -webkit-flex;
        width:285px ;
        padding-left: 10px;
        padding-right: 10px;
    }
    .sp2{
        display: flex;
        display: -webkit-flex;
        line-height: 40px;
    }
    .smallp{
        height: 32px;
        line-height: 32px;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        outline: none;
        padding:0 15px 0 15px;
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;

    }
    .qrxg {
    width: 132px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: rgb(255, 255, 255);
    cursor: pointer;
    box-shadow: rgb(153, 153, 153) 1px 1px 4px;
    margin: 10px auto 20px;
    border-radius: 16px;
    background: #8CBB77;
    }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/xitong/mima.vue